import { useTiMaxStore } from "@ti/max";
import { routes } from "../../config/common";
import zhCN from "../locales/zh-CN/menu";
import enUS from "../locales/en-US/menu";

const getMenu = (arr) => {
  return arr
    .filter((v) => v.status !== 0)
    .filter((v) => v.type === 0)
    .map((v) => {
      return {
        path: v.uri,
        children: v.childList ? getMenu(v.childList) : [],
        key: v.id,
        icon: v.icon,
      };
    });
};

const getAccess = (menu) => {
  const access = [];
  const recursion = (arr) => {
    arr.forEach((element) => {
      // 类型为按钮且状态为正常
      if (element.type === 1 && element.status) {
        access.push(element.id);
      }
      if (element.childList) {
        recursion(element.childList);
      }
    });
  };
  recursion(menu);
  return access;
};

const routesMap = (() => {
  const map = {};
  const flatRoutes = (menus) => {
    menus.forEach((v) => {
      if (v.key) {
        map[v.key] = v;
      }
      if (v.routes) {
        flatRoutes(v.routes);
      }
    });
  };
  flatRoutes(routes);
  return map;
})();

/**
 * 转化菜单（给 Spiral App 使用）
 */
const transformMenu = (menuList) => {
  menuList.forEach((v) => {
    const { path, microAppPath } = routesMap[v.key] || {};
    if (path) {
      v.path = path;
    }
    if (microAppPath) {
      v.microAppPath = microAppPath;
    }
    if (v.children?.length > 0) {
      transformMenu(v.children);
    } else if (routesMap[v.key]) {
      v.children = routesMap[v.key].routes;
    }
  });
};

/**
 * 翻译菜单
 */
const translateMenu = (menuList) => {
  const { locale } = useTiMaxStore.getState();
  menuList.forEach((v) => {
    const cname = zhCN[`menu.${v.key}`];
    const ename = enUS[`menu.${v.key}`];
    v.cname = cname;
    v.ename = ename;
    v.name = locale === "zh-CN" ? cname : ename;
    if (v.children) {
      translateMenu(v.children);
    }
  });
};

const getUserInfoFromResponse = (input) => {
  const {
    ctUserId,
    userName,
    userAccount,
    companyId,
    companyName,
    regionId,
    regionName,
    token,
    menuList,
    phone,
    role,
    xxFlag,
  } = input;
  const menu = getMenu(menuList);
  const access = getAccess(menuList);
  transformMenu(menu);
  translateMenu(menu);
  return {
    userInfo: {
      userId: ctUserId,
      userName,
      userAccount,
      companyId,
      companyName,
      regionId,
      regionName,
      phone,
      role,
      xxFlag,
    },
    token,
    menu,
    access,
  };
};

export default getUserInfoFromResponse;
